import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { PatientService } from 'services/patient';
import { type PatientRecord } from 'types/patient';

const POLLING_INTERVAL_MS = 3000;

interface UseFetchActivePatientRecordOptions {
  polling?: boolean;
}

export const useFetchActivePatientRecord = (
  patientId: string,
  { polling = false }: UseFetchActivePatientRecordOptions = {}
): UseQueryResult<PatientRecord> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT_RECORD, patientId],
    queryFn: async () => PatientService.getActiveRecord(patientId),
    select: response => response.data,
    enabled: !!patientId,
    staleTime: FIFTEEN_MINUTES,
    refetchInterval: polling
      ? (query): number | false => (query.state.data?.data?.code ? false : POLLING_INTERVAL_MS)
      : false,
  });
